module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Medium-75386ce120ebb0f9c95d5b422e11931a.svg";